function Reload() {
  window.location.reload();
  return null;
}

export default Reload;
